/**
 * Small fixed pill that shows which branch + commit is being previewed.
 * Only renders when VITE_BRANCH is set, so it's invisible in:
 *   - local sandbox dev (no .env.local with VITE_BRANCH)
 *   - production builds (env vars baked in only if we choose to)
 *
 * Populated by /home/ubuntu/bin/moneyschool-preview on Chris's EC2 box.
 */

import { useState } from "react";

const branch = (import.meta.env.VITE_BRANCH as string | undefined) ?? "";
const commitShort = (import.meta.env.VITE_COMMIT_SHORT as string | undefined) ?? "";
const commitMsg = (import.meta.env.VITE_COMMIT_MSG as string | undefined) ?? "";
const buildTime = (import.meta.env.VITE_BUILD_TIME as string | undefined) ?? "";

export default function BuildInfoBadge() {
  const [expanded, setExpanded] = useState(false);

  if (!branch) return null;

  const isMain = branch === "main";
  const accent = isMain ? "#10b981" : "#fb923c";

  return (
    <div
      onClick={() => setExpanded(e => !e)}
      style={{
        position: "fixed",
        left: 8,
        bottom: "calc(90px + env(safe-area-inset-bottom, 0px))",
        zIndex: 40,
        background: "rgba(15, 23, 42, 0.85)",
        color: "#fff",
        padding: expanded ? "8px 12px" : "4px 8px",
        borderRadius: 10,
        fontSize: 10,
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        fontWeight: 600,
        cursor: "pointer",
        maxWidth: expanded ? 280 : 200,
        lineHeight: 1.4,
        boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
        borderLeft: `3px solid ${accent}`,
        transition: "max-width 0.2s, padding 0.2s",
      }}
      title="Tap to expand build info"
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ color: accent }}>●</span>
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {branch}
        </span>
        <span style={{ opacity: 0.6 }}>@{commitShort}</span>
      </div>
      {expanded && (
        <div style={{ marginTop: 6, fontSize: 9, opacity: 0.8, fontWeight: 400 }}>
          {commitMsg && <div style={{ marginBottom: 2 }}>{commitMsg}</div>}
          {buildTime && <div style={{ opacity: 0.6 }}>built {buildTime}</div>}
        </div>
      )}
    </div>
  );
}
